import BarChartIcon from '@mui/icons-material/BarChart'
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined'
import { Button } from '@mui/material'

interface Props {
  showingData: boolean
  onToggle: () => void
}

export const ViewDataButton = ({ showingData, onToggle }: Props) => (
  <Button
    size='small'
    variant='outlined'
    startIcon={showingData ? <BarChartIcon /> : <TableRowsOutlinedIcon />}
    onClick={onToggle}>
    {showingData ? 'View chart' : 'View data'}
  </Button>
)
